/**
 * Styleguide Theme Toggle
 *
 * Self-injecting dark/light toggle button for styleguide pages (.sg-page).
 * Renders a fixed-position button in the top-right corner.
 * Persists choice to localStorage so it sticks across page loads.
 */

(function () {
  if (!document.body.classList.contains('sg-page')) return;

  // Ensure data-theme is set (pages may not have it on <html>)
  const saved = localStorage.getItem('sg-theme');
  document.documentElement.setAttribute('data-theme', saved || 'dark');

  // Create toggle button
  const btn = document.createElement('button');
  btn.className = 'sg-theme-toggle';
  btn.setAttribute('type', 'button');
  btn.setAttribute('aria-label', 'Toggle theme');
  btn.innerHTML = '<i class="fa-solid fa-circle-half-stroke"></i>';

  btn.addEventListener('click', function () {
    const html = document.documentElement;
    const current = html.getAttribute('data-theme') || 'dark';
    const next = current === 'dark' ? 'light' : 'dark';
    html.setAttribute('data-theme', next);
    localStorage.setItem('sg-theme', next);
  });

  document.body.appendChild(btn);
})();
